module.exports = __webpack_public_path__ + "img/16.d3f54694.jpg";